"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Utilities = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _types = require("../types"),
  _kameleoonData = require("../kameleoonData"),
  _constants = require("../constants"),
  _targeting = require("../targeting"),
  _types2 = require("./types"),
  _constants2 = require("./constants"),
  _validator = require("./validator"),
  _logging = require("../logging");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Utilities = /*#__PURE__*/function () {
  function Utilities() {
    _classCallCheck(this, Utilities);
  }
  return _createClass(Utilities, null, [{
    key: "getNonce",
    value: function getNonce(a) {
      var b = "";
      for (var c = 0; c < _constants2.NONCE_LENGTH; c++) {
        var _c = a.getRandomNumber(),
          d = Math.floor(_c * _constants2.NONCE_LENGTH);
        b += _constants2.HEX_CHARACTERS.charAt(d);
      }
      return b;
    }
  }, {
    key: "checkTargeting",
    value: function checkTargeting(a) {
      var b = a.segment,
        c = a.visitorCode,
        d = a.targetingData,
        e = a.experimentId,
        f = a.variationConfiguration,
        g = a.clientConfiguration,
        h = a.packageInfo,
        i = a.dataManager;
      if (_logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: checkTargeting(segment, visitorCode: ", ", targetingData: ", ", experimentId: ", ", variationConfiguration, clientConfiguration, packageInfo, dataManager)"])), c, d, e), !b || !b.conditionsData.firstLevel.length) {
        var _a = (0, _tsRes.Ok)(!0);
        return _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN checkTargeting(segment, visitorCode: ", ", targetingData: ", ", experimentId: ", ", variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ", ")"])), c, d, e, _a), _a;
      }
      if (!f) {
        var _a2 = (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.Initialization));
        return _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["RETURN checkTargeting(segment, visitorCode: ", ", targetingData: ", ", experimentId: ", ", variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ", ")"])), c, d, e, _a2), _a2;
      }
      var j = {};
      var k = f.getStoredVariations(c);
      k.ok && (j = k.data);
      var l = i.getTree(b);
      var m, n, o;
      l.hasTargetingType(_targeting.TargetingType.SEGMENT) && (m = i.trees, o = g.segments), l.hasTargetingType(_targeting.TargetingType.TARGET_FEATURE_FLAG) && (n = g.ruleMap);
      var p = l.evaluate({
        variationData: j,
        sdkInfo: h,
        segments: o,
        ruleMap: n,
        trees: m,
        targetingData: d,
        experimentId: e,
        visitorCode: c
      });
      return _logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["RETURN checkTargeting(segment, visitorCode: ", ", targetingData: ", ", experimentId: ", ", variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ", ")"])), c, d, e, p), p;
    }
  }, {
    key: "convertTimeUnit",
    value: function convertTimeUnit(a, b) {
      var c = _defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, _types2.TimeUnit.Minute, _types.Milliseconds.Minute), _types2.TimeUnit.Hour, _types.Milliseconds.Hour), _types2.TimeUnit.Day, _types.Milliseconds.Day), _types2.TimeUnit.Week, _types.Milliseconds.Week), _types2.TimeUnit.Month, _types.Milliseconds.Month);
      return a / c[b];
    }
  }, {
    key: "isCustomData",
    value: function isCustomData(a) {
      return a.data.type === _kameleoonData.KameleoonData.CustomData;
    }
  }, {
    key: "insertInOrderedListMutably",
    value: function insertInOrderedListMutably(a) {
      var b = a.list,
        c = a.element,
        d = a.order;
      if (!b.includes(c)) {
        var _a3 = b.findIndex(function (a) {
          return d === _types2.Order.Ascending ? a >= c : a <= c;
        });
        -1 === _a3 ? b.push(c) : b.splice(_a3, 0, c);
      }
    }
  }, {
    key: "updateCache",
    value: function updateCache(a) {
      var b = a.hasJsCssVariables,
        c = a.cacheManager,
        d = a.visitorCode,
        e = a.experimentId,
        f = a.variationId;
      var g = c.getAliveItem(d),
        h = g ? _objectSpread({}, g) : {};
      h[e] = {
        variationId: f,
        hasJsCssVariables: b,
        expirationTime: Date.now() + _constants.CACHE_ITEM_LIFETIME * _types.Milliseconds.Second
      }, c.add({
        key: d,
        data: h,
        lifetime: _constants.CACHE_ITEM_LIFETIME
      });
    }
  }, {
    key: "getTrackingCode",
    value: function getTrackingCode(a, b) {
      var c = "window.kameleoonQueue=window.kameleoonQueue||[];";
      var d = a.getAliveItem(b);
      if (!d) return c;
      var e = {};
      return Object.entries(d).forEach(function (a) {
        var _a4 = _slicedToArray(a, 2),
          b = _a4[0],
          _a4$ = _a4[1],
          d = _a4$.variationId,
          f = _a4$.expirationTime,
          g = _a4$.hasJsCssVariables;
        f > Date.now() && (c += "window.kameleoonQueue.push(['Experiments.assignVariation',".concat(b, ",").concat(d, ",true]);"), c += "window.kameleoonQueue.push(['Experiments.trigger',".concat(b, ",").concat(!g, "]);"), e[+b] = {
          variationId: d,
          expirationTime: f,
          hasJsCssVariables: g
        });
      }), a.add({
        key: b,
        data: e,
        lifetime: _constants.CACHE_ITEM_LIFETIME
      }), c;
    }
  }, {
    key: "compareSemVer",
    value: function compareSemVer(a) {
      var b = a.version,
        c = a.compareVersion,
        d = a.operator;
      var e = _validator.Validator.validateVersion(b),
        f = _validator.Validator.validateVersion(c);
      if (!e.ok) return (0, _tsRes.Err)(e.error);
      if (!f.ok) return (0, _tsRes.Err)(f.error);
      var _e$data = _slicedToArray(e.data, 3),
        g = _e$data[0],
        h = _e$data[1],
        i = _e$data[2],
        _f$data = _slicedToArray(f.data, 3),
        j = _f$data[0],
        k = _f$data[1],
        l = _f$data[2],
        m = g === j,
        n = h === k,
        o = i === l;
      switch (d) {
        case _targeting.VersionMatchType.EQUAL:
          return (0, _tsRes.Ok)(m && n && o);
        case _targeting.VersionMatchType.GREATER:
          return (0, _tsRes.Ok)(g > j || m && h > k || m && n && i > l);
        case _targeting.VersionMatchType.LOWER:
          return (0, _tsRes.Ok)(g < j || m && h < k || m && n && i < l);
        default:
          _logging.KameleoonLogger.error(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["Unknown version match type: ", ""])), d), (0, _kameleoonError.exhaustCheck)(d);
      }
    }
  }]);
}();
exports.Utilities = Utilities;